export default class SurveyService {
  constructor(bRoot) {
    this.bRoot = bRoot;
    this.app = "/data/";
    this.getCrops = this.getCrops.bind(this);
    this.save = this.save.bind(this);
    this.search = this.search.bind(this);
    this.getCampaigns = this.getCampaigns.bind(this);
    this.getSurveyCampaigns = this.getSurveyCampaigns.bind(this);
    this.campaignInitialize = this.campaignInitialize.bind(this);
    this.campaignSave = this.campaignSave.bind(this);
    this.initialize = this.initialize.bind(this);
  }

  async getCrops() {
    return await this.bRoot.search(
      this.app + "crops",
      null,
      "description",
      null
    );
  }

  async getCampaigns() {
    // eslint-disable-next-line
    return await this.bRoot.search(this.app + "campaigns", null, "-code", null);
  }

  getSurveyCampaigns(survey_id, crop_id, campaign_id) {
    let filterstring =
      "survey__id=" +
      survey_id.toString() +
      (crop_id ? "&crop__id=" + crop_id.toString() : "") +
      (campaign_id ? "&campaign__id=" + campaign_id.toString() : "");

    // eslint-disable-next-line
    return this.bRoot.search(this.app + "survey_campaigns", null, "-campaign__code,crop__description", filterstring);
  }

  campaignInitialize(survey, crop, campaign) {
    return {
      url: null,
      survey_campaign: null,
      survey: survey.survey,
      survey_id: survey.survey_id,
      crop: crop ? crop.url : null,
      crop_id: crop ? crop.id : null,
      crop_description: crop ? crop.description : null,
      campaign: campaign ? campaign.url : null,
      campaign_id: campaign ? campaign.id : null,
      campaign_code: campaign ? campaign.code : null,
      hectare: 0,
      campaign_current: true,
      commercial_person: this.bRoot.appInfo.commercial_person.url
    };
  }

  async initialize(producer, territory, commercialPerson) {
    // eslint-disable-next-line
    let current_level = this.bRoot.appInfo.commercial_person.commercial_person_type.level
    let object = {
      url: null,
      id: null,
      territory: territory ? territory.territory : null,
      territory_id: territory ? territory.id : null,
      territory_level: territory ? territory.level : null,
      territory_description: territory ? territory.description : null,
      territory_type_description: territory ? territory.description_type : null,
      producer: producer ? producer.url : null,
      producer_id: producer ? producer.id : null,
      producer_name: producer ? producer.name : null,
      producer_identification: producer ? producer.identification : null,
      contact_name: null,
      contact_email: null,
      contact_phone: null
    };
    if (current_level === 3) {
      object.commercial_person = this.bRoot.appInfo.commercial_person.url;
      object.commercial_person_id = this.bRoot.appInfo.commercial_person.id;
      object.commercial_person_name = this.bRoot.appInfo.commercial_person.person.name;
      object.commercial_person_type_description = this.bRoot.appInfo.commercial_person.commercial_person_type.description;
    } else if (current_level === 4) {
      // eslint-disable-next-line
      let response = await this.bRoot.getObjectByURL(this.bRoot.appInfo.commercial_person.superior)
      if (response) {
        object.commercial_person = response.url;
        object.commercial_person_id = response.id;
        object.commercial_person_name = response.person_name;
        object.commercial_person_type_description =
          response.commercial_person_type_description;
      } else {
        object.commercial_person = null;
        object.commercial_person_id = null;
        object.commercial_person_name = null;
        object.commercial_person_type_description = null;
      }
      return object;
    } else {
      object.commercial_person = commercialPerson
        ? commercialPerson.commercial_person
        : null;
      object.commercial_person_id = commercialPerson
        ? commercialPerson.commercial_id
        : null;
      object.commercial_person_name = commercialPerson
        ? commercialPerson.name
        : null;
      object.commercial_person_type_description = commercialPerson
        ? commercialPerson.commercial_type_description
        : null;
    }
    return object;
  }

  async canEditTerritory(survey) {
    try {
      if (!survey.url) {
        return true;
      } else {
        let campaigns = await this.bRoot.search(
          this.app + "survey_campaigns",
          null,
          "-campaign__code",
          "survey__id=" +
            survey.survey_id.toString() +
            "&campaign__current=false"
        );
        return campaigns.data.results.length > 0 ? false : true;
      }
    } catch (error) {
      return false;
    }
  }

  save(args) {
    return Promise.resolve()
      .then(() => {
        //validate information
        if (this.bRoot.isNullOrEmpty(args, "producer")) {
          throw "Debe seleccionar un productor";
        }
        if (this.bRoot.isNullOrEmpty(args, "territory")) {
          throw "Debe seleccionar un territorio";
        }
        if (this.bRoot.isNullOrEmpty(args, "commercial_person")) {
          throw "Debe seleccionar un Agente";
        }
        if (this.bRoot.isNullOrEmpty(args, "contact_name")) {
          throw "Debe ingresar un nombre de contacto";
        }
        let object = {
          producer: args.producer,
          territory: args.territory,
          commercial_person: args.commercial_person,
          contact_name: args.contact_name,
          contact_email: args.contact_email,
          contact_phone: args.contact_phone
        };
        if (args.url) {
          object.url = args.url;
        }
        if (object.url) {
          return this.bRoot.save(object);
        } else {
          return this.bRoot.add(this.app + "surveys", null, object);
        }
      })
      .catch(error => {
        this.bRoot.setError(error);
        return null;
      });
  }

  search(filterstring, searchAll, page) {
    return Promise.resolve()
      .then(() => {
        return this.bRoot.search(
          this.app + (searchAll === true ? "surveys" : "surveys_hierarchy"),
          null,
          "commercial_person_name",
          filterstring,
          page
        );
      })
      .catch(() => {
        return null;
      });
  }

  campaignSave(args) {
    return Promise.resolve()
      .then(() => {
        if ((args.hectare ? args.hectare : "").match(/\D/) != null) {
          throw "El dato hectáres debe ser numérico sin decimales";
        }
        if (this.bRoot.isNullOrEmpty(args, "hectare")) {
          throw "Ingrese cantidad de hectáreas";
        }
        let object = {
          url: args.url ? args.url : args.survey_campaign,
          crop: args.crop,
          survey: args.survey,
          campaign: args.campaign,
          hectare: args.hectare,
          commercial_person: this.bRoot.appInfo.commercial_person.url
        };
        if (object.url) {
          return this.bRoot.save(object);
        } else {
          return this.bRoot.add(
            this.app + "survey_campaigns",
            "survey__id=" +
              args.survey_id.toString() +
              "&campaign__id=" +
              args.campaign_id.toString() +
              "&crop__id=" +
              args.crop_id.toString(),
            object
          );
        }
      })
      .catch(error => {
        if (!this.bRoot.errors) {
          this.bRoot.setError(error);
        }
        return null;
      });
  }
}
